
import {Injectable} from '@angular/core';
import { Router, Route } from '@angular/router';

import { ToasterService, Toast, BodyOutputType  } from 'angular2-toaster';
import {Validator} from '../@core/data/model/validator';
import swal, { SweetAlertType } from 'sweetalert2';
import { Partenaire } from '../@core/data/model/partenaire';
import { Facture } from '../@core/data/model/facture';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { FluxStock } from '../@core/data/model/fluxstock';
import { Reglement } from '../@core/data/model/reglement';
import { Produit } from '../@core/data/model/produit';
import { Compte } from '../@core/data/model/compte';
import { Flux } from '../@core/data/model/flux';
import { Plantarifaire } from '../@core/data/model/plantarifaire';
import { User } from '../@core/data/model/user';
// import { AuthService } from '../auth/auth.service';
import { Company } from '../@core/data/model/company';
import { Inventaire } from '../@core/data/model/inventaire';
import { Commande } from '../@core/data/model/commande';
import { Bordereau } from '../@core/data/model/bordereau';
import { SettingService } from '../@core/data/rest/setting-service';
import { CatProduit } from '../@core/data/model/catproduit';
import { CashSession } from '../@core/data/model/cashsession';
import { Subject } from 'rxjs';
import { Taxe } from '../@core/data/model/taxe';



@Injectable()
export class SharedMethods {

  dtStruct: NgbDateStruct;


  constructor(private toasterService: ToasterService, private router: Router, public settingService: SettingService) { }

  errorApiShow(code: Number, message: string) {

    if ( code === undefined) {

        this.settingService.search = false;
        this.sweetalert('error', 'Echec de connexion', 'Aucune réponse du serveur. Vérifier votre connexion et réessayez !');

        // this.toastShow('error', 'Echec de connexion', 'Aucune réponse du serveur. Vérifier votre connexion et réessayez !');

    } else {

        if ( code === 401 ) {
          // erreur du à l'invalidité du token
          /* this.settingService.search = false;
          this.router.navigate(['/auth/pages/login']); */
          this.settingService.search = false;
          this.router.navigate(['/pages/login']);

        } else {

            /*
            // tslint:disable-next-line:no-console
            console.log(code);
            // tslint:disable-next-line:no-console
            console.log(message);
            */

            /* swal({
                type: 'error',
                title: 'Erreur interne au serveur',
                text: 'Contactez votre administrateur!',
                allowOutsideClick: false,
            }); */

            this.settingService.search = false;

            this.sweetalert('error', 'Echec de l\'opération', message);

        }


    }

  }

  // le module  est importer depuis le app.module.ts ( toaster-container est défini dans le  template du app module et le toasterconfig dans sont app.component
  toastShow(type: string, title: string, body: string) {
    const toast: Toast = {
        type: type, // 'default', 'info', 'success', 'warning', 'error'
        title: title,
        body: body,
        timeout: 5000,
        showCloseButton: false,
        bodyOutputType: BodyOutputType.TrustedHtml,
      };
      this.toasterService.pop(toast);
  }

  sweetalert(typealert: SweetAlertType, title: string, body: string) {

    swal({
      type: typealert,
      title: title,
      // text : body,
      html: body,
      allowOutsideClick: false,
    });

  }



  validateEmail(email): boolean {
    const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    return emailRegex.test(email);
  }

  validateFluxstock (fluxstock: FluxStock, quantiteMax: number) {
      // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (fluxstock.produit === undefined || fluxstock.produit === null) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Selectionner un produit dans la liste';
      return validator;
    }

    if (fluxstock.quantite === undefined || fluxstock.quantite === 0 || fluxstock.quantite === null) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'La quantité doit être supérieur à 0';
      return validator;
    } else {

      if ( quantiteMax !== null && fluxstock.quantite > quantiteMax) {
        validator.result = false;
        validator.title = 'Erreur';
        validator.message = 'Quantité supérieur à la quantité maximal : ' + quantiteMax;
        return validator;
      }

    }

    /* if (fluxstock.quantite < fluxstock.retour) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Vous ne pouvez pas retourner une quantité supérieur à celle vendue (' + fluxstock.quantite + ') ! ';
      return validator;
    } */

    if (fluxstock.prix_unitaire === undefined || fluxstock.prix_unitaire === 0 || fluxstock.prix_unitaire === null) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'La prix doit être supérieur à 0';
      return validator;
    }

    return validator;
  }

  validateCommande (commande: Commande) {
    // tslint:disable-next-line:prefer-const
  let validator = new Validator();
  validator.result = true;

  if (commande.produit === undefined) {
    validator.result = false;
    validator.title = 'Erreur';
    validator.message = 'Selectionner un produit dans la liste';
    return validator;
  }

  if (commande.description === undefined || commande.description === '') {
    validator.result = false;
    validator.title = 'Erreur';
    validator.message = 'Entrez une description de la commande';
    return validator;
  }

  if (commande.quantite === undefined || commande.quantite === 0 || commande.quantite === null) {
    validator.result = false;
    validator.title = 'Erreur';
    validator.message = 'Entrez un nombre supérieur à 0';
    return validator;
  }


  if (commande.prix_unitaire === undefined || commande.prix_unitaire === 0 || commande.prix_unitaire === null) {
    validator.result = false;
    validator.title = 'Erreur';
    validator.message = 'Entrez un prix supérieur à 0';
    return validator;
  }

  return validator;

}


  validateReglement (reglement: Reglement) {
    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

   /*  if (reglement.date_flux === undefined || reglement.date_flux === '') {
      validator.result = false;
      validator.title = 'Date non valide';
      validator.message = 'Selectionner une date';
      return validator;
    } */

    /* if (reglement.nature_reglement === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Selectionner un mode de règlement dans la liste';
      return validator;
    } */


    if (reglement.facture === undefined && reglement.id_facture === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Selectionnez une facture';
      return validator;
    }


    if (reglement.montant === undefined || reglement.montant <= 0) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Entrez un montant supérieur à 0';
      return validator;
    }


    if (reglement.cashsession === undefined ) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Selectionner un compte de trésorerie';
      return validator;
    }

    /* if (reglement.montant > reglement.facture.reste) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Entrez un montant inférieur ou égale ' + reglement.facture.reste + ' pour regler cette facture';
      return validator;
    } */

    return validator;
  }


  validateFlux (flux: Flux, type: string, compteselect: boolean, isDepense: boolean) {
    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (isDepense && flux.op_compte === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      // validator.message = 'Selectionnez << Entrée >> ou << Sortie >>';
      validator.message = 'Veillez spécifier la catégorie de dépense';
      return validator;
    }

    if (flux.type_flux !== 'entree' && flux.type_flux !== 'sortie') {
      validator.result = false;
      validator.title = 'Erreur';
      // validator.message = 'Selectionnez << Entrée >> ou << Sortie >>';
      validator.message = 'Selectionnez le type d\'opération << Entrée >> ou << Sortie >>';
      return validator;
    }

    if (flux.nature_flux === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Donnez la nature';
      return validator;
    }

    if ((type === 'Versement' || type === 'Transfert') &&  !compteselect) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Aucun compte selectionnez';
      return validator;
    }

    // on commente si on veux gerer les comptes de prévisions
    /* if (flux.montant === undefined || flux.montant <= 0) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Entrez un montant supérieur à 0';
      return validator;
    } */


    return validator;
  }

  validateFacture (facture: Facture, validate: boolean, cmd: Commande[], idcompte: number) {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    /* if (facture.date_facturation === undefined || facture.date_facturation === '') {
      validator.result = false;
      validator.title = 'Date non valide';
      validator.message = 'Selectionner une date';
      return validator;
    } */

    /* if (facture.partenaire === undefined || facture.partenaire === null) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Selectionnez un partenaire!';
      return validator;
    } */

    if ( cmd === undefined || cmd === null || cmd.length === 0) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Aucun produit commandé!';
      return validator;
    }

    if ( validate && facture.payer  &&  idcompte === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Selectionnez un compte de trésorerie';
      return validator;
    }


    const datefacturation  = new Date(facture.date_facturation);

    /* if (facture.date_echeance !== '' && facture.date_echeance !== undefined  && facture.date_echeance !== null) {

      if (datefacturation.getTime() > dateecheance.getTime()) {
        validator.result = false;
        validator.title = 'Date échéance non valide';
        validator.message = 'La date d\'échéance doit être supérieur ou égale à la de facturation';
        return validator;
      }

    } */

    /* const dateClotureVente  = new Date(dateCloture);

    if (datefacturation.getTime() <= dateClotureVente.getTime()) {

      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'La date de facturation doit être supérieur à la date de clôture des opérations';
      return validator;

    } */

    // validation des livraisons et retour
    /* for (let i = 0; i < facture.produitsCommande.length; i++ ) {

        if (facture.qteLivrerByProd(facture.produitsCommande[i].id) < facture.qteRetourByProd(facture.produitsCommande[i].id)) {

          validator.result = false;
          validator.title = 'Erreur';
          validator.message = 'Quantité livrée (' + facture.qteLivrerByProd(facture.produitsCommande[i].id) + ') ' + facture.produitsCommande[i].designation + ' ne correspond pas à la  quantité retournée ( ' + facture.qteRetourByProd(facture.produitsCommande[i].id) + ' )';
          return validator;

        }

    } */

    return validator;

  }

  validateBordereau (bordereau: Bordereau, fluxstock: FluxStock[]) {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    /* if (facture.date_facturation === undefined || facture.date_facturation === '') {
      validator.result = false;
      validator.title = 'Date non valide';
      validator.message = 'Selectionner une date';
      return validator;
    } */

    if ( fluxstock === undefined || fluxstock === null || fluxstock.length === 0) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Ajouter au moins une commande!';
      return validator;
    }


    return validator;

  }

  validatePlantarifaire(plan: Plantarifaire, listplan: Plantarifaire[]): Validator {

    const validator = new Validator();
    validator.result = true;

    if (plan.designation === '' || plan.designation === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'La désigantion  ne doit pas être vide';
      return validator;
    }else {
      for (const elem of listplan) {
        if (elem.designation !== null) {
          if ( elem.id !== plan.id && elem.designation.toLowerCase() === plan.designation.toLowerCase()) {
            validator.result = false;
            validator.title = 'Erreur';
            validator.message = 'désignation déjà utilisé';
            return validator;
          }
        }
      }
    }

    return validator;

  }

  validateSession(session: CashSession) {
    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (session.nom === '' || session.nom === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le nom  ne doit pas être vide';
      return validator;
    }

    if (session.nature === 'depot' && session.partenaire === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Aucun client selectionné';
      return validator;
    }

    return validator;

  }

  validatePartner(partner: Partenaire, listpartner: Partenaire[]): Validator {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (partner.nom === '' || partner.nom === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le nom  ne doit pas être vide';
      return validator;
    }

    /* if (partner.prenom === '') {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le prenom du client ne doit pas être vide';
      return validator;
    } */

    if (partner.email !== undefined && partner.email !== null) {

        const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

        if ( !( this.validateEmail(partner.email) ) ) { // on se rassure que l'email est valide
            validator.result = false;
            validator.title = 'Erreur';
            validator.message = 'Email incorrecte ex : example@mail.com';
            return validator;
        }else {
          if (listpartner !== undefined) {
            for (const elem of listpartner) {
              if (elem.email !== null) {
                if ( elem.id !== partner.id && elem.email.toLowerCase() === partner.email.toLowerCase()) {
                  validator.result = false;
                  validator.title = 'Erreur';
                  validator.message = 'Email déjà utilisé';
                  return validator;
                }
              }
            }
          }
        }


    }

    if (partner.tel !== undefined  && partner.tel !== null  && listpartner !== undefined) {

      for (const elem of listpartner) {
        if (elem.tel !== null ) {
          if ( elem.id !== partner.id && elem.tel.toLowerCase() === partner.tel.toLowerCase()) {
            validator.result = false;
            validator.title = 'Erreur';
            validator.message = 'Numéro Téléphone déjà utilisé';
            return validator;
          }
        }
      }

    }

    return validator;

  }


  validateUser(user: User, listuser: User[]): Validator {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (user.email === '' || user.email === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'l\'email  ne doit pas être vide';
      return validator;
    }

    if (user.email !== undefined && user.email !== null) {

        const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

        if ( !( this.validateEmail(user.email) ) ) { // on se rassure que l'email est valide
            validator.result = false;
            validator.title = 'Erreur';
            validator.message = 'Email incorrecte ex : example@mail.com';
            return validator;
        }else {
          if (listuser !== undefined) {
            for (const elem of listuser) {
              if (elem.email !== null) {
                if ( elem.id !== user.id && elem.email.toLowerCase() === user.email.toLowerCase()) {
                  validator.result = false;
                  validator.title = 'Erreur';
                  validator.message = 'Email déjà utilisé';
                  return validator;
                }
              }
            }
          }
        }

    }

    /* if (user.name === '' || user.name === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le nom  ne doit pas être vide';
      return validator;
    } */

    if (user.name === '' || user.name === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le nom ne doit pas être vide';
      return validator;
    }

    if (user.id === 0 && (user.password === undefined || user.password === null || user.password === '')) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le mot de passe ne doit pas être vide';
      return validator;
    }


    /* if (user.tel !== undefined  && partner.tel !== null  && listpartner !== undefined) {

      for (const elem of listpartner) {
        if (elem.tel !== null ) {
          if ( elem.id !== partner.id && elem.tel.toLowerCase() === partner.tel.toLowerCase()) {
            validator.result = false;
            validator.title = 'Erreur';
            validator.message = 'Numéro Téléphone déjà utilisé';
            return validator;
          }
        }
      }

    } */

    return validator;

  }


  validateTaxe(taxe: Taxe, listtaxe: Taxe[]): Validator {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (taxe.designation === '' || taxe.designation === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'La designation  ne doit pas être vide';
      return validator;
    } else {

      for (const elem of listtaxe) {
        if (elem.designation !== null) {
          if ( elem.id !== taxe.id && elem.designation.toLowerCase() === taxe.designation.toLowerCase()) {
            validator.result = false;
            validator.title = 'Erreur';
            validator.message = 'Designation déjà utilisé';
            return validator;
          }
        }
      }
    }

    if (taxe.type_calcul === '' || taxe.type_calcul === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Type calcul invalide';
      return validator;
    }

    if (taxe.valeur === 0 || taxe.valeur === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'La valeur doit être supérieur à 0';
      return validator;
    }

    return validator;

  }

  validateProduit(product: Produit, listproduit: Produit[]): Validator {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (product.designation === '' || product.designation === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le nom  ne doit pas être vide';
      return validator;
    } else {
      for (const elem of listproduit) {
        if (elem.designation !== null) {
          if ( elem.id !== product.id && elem.designation.toLowerCase() === product.designation.toLowerCase()) {
            validator.result = false;
            validator.title = 'Erreur';
            validator.message = 'Nom produit déjà utilisé';
            return validator;
          }
        }
      }
    }

    if (product.is_promo && ( product.prix_promo === undefined || product.prix_promo === null || product.prix_promo === 0)) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Prix de promotion non définir';
      return validator;
    } 

    return validator;

  }

  validateCatProduit(cat: CatProduit, listcat: CatProduit[]): Validator {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (cat.nom === '' || cat.nom === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le nom  ne doit pas être vide';
      return validator;
    } else {
      for (const elem of listcat) {
        if (elem.nom !== null) {
          if ( elem.id !== cat.id && elem.nom.toLowerCase() === cat.nom.toLowerCase()) {
            validator.result = false;
            validator.title = 'Erreur';
            validator.message = 'Nom déjà utilisé';
            return validator;
          }
        }
      }
    }

    return validator;

  }


  validateCompte(compt: Compte, listcomptes: Compte[]): Validator {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (compt.designation === '' || compt.designation === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le champ designation  ne doit pas être vide';
      return validator;
    } /* else {
      for (const elem of listproduit) {
        if (elem.designation !== null) {
          if ( elem.id !== product.id && elem.designation.toLowerCase() === product.designation.toLowerCase()) {
            validator.result = false;
            validator.title = 'Erreur';
            validator.message = 'Nom produit déjà utilisé';
            return validator;
          }
        }
      }
    } */

    return validator;

  }

  validateCat(cat: CatProduit, listcats: CatProduit[]): Validator {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (cat.nom === '' || cat.nom === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le champ nom  ne doit pas être vide';
      return validator;
    } /* else {
      for (const elem of listproduit) {
        if (elem.designation !== null) {
          if ( elem.id !== product.id && elem.designation.toLowerCase() === product.designation.toLowerCase()) {
            validator.result = false;
            validator.title = 'Erreur';
            validator.message = 'Nom produit déjà utilisé';
            return validator;
          }
        }
      }
    } */

    return validator;

  }

  validateInventaire(inventory: Inventaire): Validator {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    /* if (inventory.reference === '' || inventory.reference === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le champ référence  ne doit pas être vide';
      return validator;
    } */

    if (inventory.products === undefined || inventory.products.length === 0 ) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Aucun produit trouvé';
      return validator;
    }

    return validator;

  }

converNgbDateStructToString(date: NgbDateStruct): string {
    if (date !== null && date !== undefined)
    return date.year.toString() + '-' + date.month.toString() + '-' + date.day.toString();
    else
    return null;
}

converStringToNgbDateStruct(date: string): NgbDateStruct {
  if (date !== null && date !== undefined) {
    const tab = date.split('-');
    return {
      year: Number( tab[0]),
      month: Number( tab[1]),
      day: Number( tab[2]),
    };
  } else {
    return null;
  }

}

converStringToDatetime(date: string): any {

  if (date !== undefined && date !== '' && date !== null) {

      const tabDate = date.split(' ');
      const tab = tabDate[0].split('-');

      if (tabDate[1] === undefined) {

        return {
          date: {
            year: Number(tab[0]),
            month: Number(tab[1]),
            day: Number(tab[2]),
          },
          time: {
            hour: 0,
            minute: 0,
          },
        };

      } else {

        const tabtime = tabDate[1].split(':');

        return {
          date: {
            year: Number(tab[0]),
            month: Number(tab[1]),
            day: Number(tab[2]),
          },
          time: {
            hour: Number(tabtime[0]),
            minute: Number(tabtime[1]),
          },
        };

      }

      // const tab = date.split('-');

  } else {
      return null;
  }


}


validateCompany(company: Company) {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (company.name === '' || company === undefined) {
      validator.result = false;
      validator.title = 'Erreur';
      validator.message = 'Le nom  ne doit pas être vide';
      return validator;
    }

    return validator;
}








}
